
import { Units } from '@/utils/enums/validUnitsEnum/unitEnum';
import { LOCAL_STORAGE_BRAND_ID, LOCAL_STORAGE_UNIT_ID } from '@/utils/constants/checkin.constants';

const getters = {
  selectedUnit({ data }) {
    return data.selectedUnit;
  },

  searchAddressGetter({ data }) {
    if (data.selectedUnit) {
      const { cep, logradouro, numero } = data.selectedUnit.endereco;
      return `https://www.google.com/maps/search/${logradouro}, ${numero}, ${cep}`;
    }

    return '';
  },

  enumUnitSelected({ data: { currentUnit } }) {
    return Object.values(Units)
      .find(unit => (
        unit.unitId === String(currentUnit.unitId)
          ? unit
          : false
      ));
  },

  isMobileService({ data }) {
    return data.unitConfigs.isMobileService;
  },

  isTrackingActiveInUnit({ data: { currentUnit } }) {
    const unitsProperties = Object.values(Units);
    return unitsProperties.find((unit) => unit.unitId === String(currentUnit.unitId))?.tracking;
  },

  getBrandUnitIdVariables({ data }) {
    return {
      brandId: parseInt(data.currentBrand.brandId) || JSON.parse(window.localStorage.getItem(LOCAL_STORAGE_BRAND_ID)),
      unitId: parseInt(data.currentUnit.unitId) || JSON.parse(window.localStorage.getItem(LOCAL_STORAGE_UNIT_ID))
    };
  },

  getUnitConfigs({ data }) {
    return data.unitConfigs;
  },

  isOcrEnableInUnit({ data }) {
    return data.unitConfigs.checkin?.ocr;
  },

  isPixPaymentEnabled({ data }) {
    return data.unitConfigs.checkin.pixPaymentEnabled;
  },
  getBrandUnitState(state) {
    return state;
  }
};

export default getters;
